var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-col justify-center items-center text-grey-darker bg-grey-lighter rounded-lg h-48 font-semibold"},[_c('EmojiSadIcon',{staticClass:"w-16 h-16"}),_vm._v(" "),_c('div',{staticClass:"text-2xl mt-5"},[_vm._v("\n        No search results...\n    ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }